import React from 'react';
import { Image, X } from 'lucide-react';

interface PhotoUploadPreviewProps {
  photos: File[];
  previewUrls: string[];
  onRemove: (index: number) => void;
  onClear: () => void;
  uploadProgress?: number;
}

export function PhotoUploadPreview({
  photos,
  previewUrls,
  onRemove,
  onClear,
  uploadProgress
}: PhotoUploadPreviewProps) {
  if (photos.length === 0) return null;

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-4 border-t border-blue-200 animate-slide-up">
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-semibold text-[#2A4494] flex items-center">
          <Image className="h-4 w-4 mr-2" />
          Photos ({photos.length})
        </span>
        <button
          onClick={onClear}
          className="text-gray-400 hover:text-red-500 transition-colors p-1 tap-target inline-flex items-center justify-center hover:bg-red-50 rounded-full shrink-0"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="flex space-x-3 overflow-x-auto pb-2 scrollbar-hide">
        {previewUrls.map((url, index) => (
          <div key={index} className="relative flex-shrink-0 group">
            <img
              src={url}
              alt={`Preview ${index + 1}`}
              className="w-20 h-20 object-cover rounded-lg shadow-md border-2 border-white group-hover:border-blue-200 transition-all duration-200"
            />
            <button
              onClick={() => onRemove(index)}
              className="absolute -top-2 -right-2 w-6 h-6 tap-target inline-flex bg-red-500 text-white rounded-full items-center justify-center text-xs hover:bg-red-600 transition-all duration-150 transform hover:scale-110 active:scale-95 shadow-lg shrink-0"
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
      </div>
      {uploadProgress !== undefined && uploadProgress > 0 && (
        <div className="mt-3 animate-fade-in">
          <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
            <div
              className="bg-gradient-to-r from-[#1B4332] to-[#2D5A3D] h-2 rounded-full transition-all duration-300 ease-out"
              style={{ width: `${uploadProgress}%` }}
            />
          </div>
          <p className="text-xs text-gray-500 mt-2 text-center">
            Uploading photos... {uploadProgress}%
          </p>
        </div>
      )}
    </div>
  );
}

